import React, { useContext } from 'react';
import classNames from 'classnames/bind';
import styles from './TipCards.module.scss';
import { FetchDataContext } from '~/component/Context/FetchDataProvider';
import TipList from './TipList';

const cx = classNames.bind(styles);

function TipCards({ type, data = [] }) {
  const { loadTips } = useContext(FetchDataContext);

  return (
    <div className={cx('container')}>
      <div className={cx('sidebar')}>
        <h2 className={cx('sidebar-title')}>{type} Tips</h2>
        <p className={cx('description')}>Dive deep into CSS features and concepts</p>
      </div>
      <TipList data={data} loadTips={loadTips} />
    </div>
  );
}

export default TipCards;
